export default "__VITE_ASSET__1ef94623__"